import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@components/buttons/Button';
import LoadingSpinner from '@components/Spinner/LoadingSpinner';
import { LambdaOperation } from '@api/lambdaOperationsApi';
import LambdaOperationCard from './LambdaOperationCard';
import { getLambdaOperationId } from '../lambdaOperations.utils';
import { ApiError } from '@api/RestClient';

type Props = {
    operations: LambdaOperation[];
    selectedOperation: LambdaOperation | null;
    loading: boolean;
    error: ApiError | null;
    onSelect: (operation: LambdaOperation) => void;
    onRetry: () => void;
};

const AvailableOperationsList = ({
    operations,
    selectedOperation,
    loading,
    error,
    onSelect,
    onRetry,
}: Props) => {
    const { t } = useTranslation();

    if (loading) {
        return (
            <div className="lambda-operations-empty">
                <LoadingSpinner size="18px" backgroundColor="transparent" />
                <span>{t('lambda-operations.loading-operations')}</span>
            </div>
        );
    }

    if (error) {
        return (
            <div className="lambda-operations-empty">
                <span>{t('lambda-operations.failed-load-operations')}</span>
                <Button text={t('lambda-operations.retry')} colorType="transparent" onClick={onRetry} />
            </div>
        );
    }

    if (!operations.length) {
        return (
            <div className="lambda-operations-empty">
                {t('lambda-operations.no-operations')}
            </div>
        );
    }

    return (
        <div className="lambda-operations-list">
            {operations.map(operation => (
                <LambdaOperationCard
                    key={getLambdaOperationId(operation) || operation.id}
                    operation={operation}
                    selected={getLambdaOperationId(operation) === getLambdaOperationId(selectedOperation || {})}
                    onSelect={onSelect}
                />
            ))}
        </div>
    );
};

export default AvailableOperationsList;
